import { useState } from 'react';
import { ReactComponent as TrashIcon } from 'assets/icons/tresh.svg';
import IconButton from 'components/IconButton/IconButton';
import DeleteModal from 'pages/CompanyAdminPages/ValueChainMap/components/DeleteModal/DeleteModal';

import type ISurveyTableActions from './interfaces/ITableMAInsightActions';

import styles from './scss/TableMAInsight.module.scss';

function TableMAInsightActions({
  surveyItem,
  onDelete,
  disableActions,
}: ISurveyTableActions) {
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteHandler = () => {
    if (onDelete) {
      onDelete(surveyItem.id);
    }
    setDeleteModalOpen(false);
  };

  return (
    <>
      <div className={styles.actionButtons}>
        <IconButton
          icon={<TrashIcon />}
          onClick={() => setDeleteModalOpen(true)}
          disabled={disableActions}
        />
      </div>
      <DeleteModal
        open={isDeleteModalOpen}
        onReject={() => setDeleteModalOpen(false)}
        onConfirm={deleteHandler}
        name={surveyItem.questionList.name}
        title="deleteSurvey"
        isLoading={false}
      />
    </>
  );
}

export default TableMAInsightActions;
